import { getSizesFromBands, ShootTimeBand } from "portal/utils/shootTime";
import { ShootTimeChartPadding, ShootTimeXScale } from "../layout";

export const DRAG_HIT_WIDTH = 16;
export const GRIP_WIDTH = 18;
export const GRIP_HEIGHT = 28;

export const getThresholdSizes = (
  bands: ShootTimeBand[],
  displaySizes: number[] | undefined
): number[] => displaySizes ?? getSizesFromBands(bands);

export const getThresholdColor = (
  bands: ShootTimeBand[],
  index: number
): string => bands[index]?.color ?? bands[0]?.color ?? "inherit";

export interface ThresholdGeometryProps {
  bands: ShootTimeBand[];
  chartPadding: ShootTimeChartPadding;
  displaySizes?: number[];
  plotHeight: number;
  xScale: ShootTimeXScale;
}
